import React from "react";
import i18n from "utils/i18n";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import VStack from 'components/atoms/stack/VStack'

const ManagementTimeslotGroupAdvancedTab = ( { saveForm, updateTimeslotGroup, timeslotGroup, isSaving }) => {

	const formFields = [
		{
			name: 'can_book_for_self',
			label: i18n.t('management:form.can_book_for_self.title'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		},
		{
			name: 'can_book_for_coworkers',
			label: i18n.t('management:form.can_book_for_coworkers.title'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		},
		{
			name: 'can_book_for_external',
			label: i18n.t('management:form.can_book_for_external.title'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		},
		{
			name: 'can_only_book_single_timeslot_per_day',
			label: i18n.t('management:form.can_only_book_single_timeslot_per_day.title'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		}
	];
	
	return (
		<VStack>
			<ThemedBlock
				shadow
				mediumPadding>
				
				<Form
					values={ timeslotGroup }
					fields={ formFields }
					onChange={ updateTimeslotGroup }
					onSubmit={ saveForm }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		</VStack>
	);
}


export default ManagementTimeslotGroupAdvancedTab
